import {
  SEND_CONTACT_MONEYTABLE,
  SEND_CONTACT_MONEYTABLE_SUCCESS,
  SEND_CONTACT_MONEYTABLE_FAILED,
  CLEAR_CONTACT_MONEYTABLE,
} from '../actions/types';

const INITIAL_STATE = {
  message: null,
  loading: false,
  success: false,
  error: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case CLEAR_CONTACT_MONEYTABLE:
      return {
        ...INITIAL_STATE,
      };
    case SEND_CONTACT_MONEYTABLE:
      return {
        ...INITIAL_STATE,
        loading: true,
      };
    case SEND_CONTACT_MONEYTABLE_SUCCESS:
      return {
        message: action.playload,
        loading: false,
        success: true,
        error: false,
      };
    case SEND_CONTACT_MONEYTABLE_FAILED:
      return {
        message: action.playload,
        loading: false,
        success: false,
        error: true,
      };
    default:
      return state;
  }
};


// WEBPACK FOOTER //
// ./src/store/contactMtReducer.js